import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../ApiHelper"
import Util from "../../Util"
import Moment from "moment"
import { TableLayout } from "../../components"
import { LoadModal } from "../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
import ReactPaginate from "react-paginate"
import { confirmAlert } from "react-confirm-alert"
class TableContratos extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
    this.getFicha = this.getFicha.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.print = this.print.bind(this)
    this.state = {
      showLoad: false
    }
  }

  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteContrato(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  getFicha(id) {
    this.toggleLoadModal()
    ApiHelper.getFichaContrato(id, (ficha, error) => {
      this.toggleLoadModal()
      if (ficha) {
        var url = URL.createObjectURL(ficha)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Ficha Contrato Número:" + id + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  print() {
    this.toggleLoadModal()
    ApiHelper.getRelacaoContratos((file, error) => {
      this.toggleLoadModal()
      if (file) {
        var date = new Date()
        var dateString =
          (date.getDate() + "").padStart(2, "0") +
          "-" +
          (date.getMonth() + "").padStart(2, "0") +
          "-" +
          date.getFullYear()

        var url = URL.createObjectURL(file)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Relação de contratos cadastrados-" + dateString + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  render() {
    var tableHeaders = [
      "Número do contrato",
      "Número do processo",
      "Objeto",
      "Contratado",
      "Assinado em",
      "Final da vigência",
      "Ações"
    ]
    var buttons = [
      {
        title: "Criar contrato",
        link: "/contratos/create",
        icon: "control_point"
      },
      { title: "Contratos deletados", link: "/contratos/trash", icon: "delete" }
    ]
    var additionalButtons = [
      {
        title: "Imprimir todos os contratos",
        callBack: this.print,
        icon: "print"
      }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          additionalButtons={additionalButtons}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar contrato"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-1">{row.num_contrato}</td>
                    <td className="col-md-1">{row.num_processo}</td>
                    <td className="col-sm-5">{row.objeto}</td>
                    <td className="col-sm-5">
                      <div>
                        {row.contratado
                          ? row.contratado.nome_razao_social
                          : "N/A"}
                      </div>
                      <div>
                        {Util.getMaskedCPFCNPJ(row.contratado ? row.contratado.cpf_cnpj : "")}
                      </div>
                    </td>
                    <td className="col-sm-1">
                      {Moment(row.data_assinado).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-1">
                      {Moment(row.final_vigencia.date).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-4 td-actions">
                      <div>
                        <Link
                          className="btn btn-primary btn-simple btn-xs"
                          title="Gerenciar contrato"
                          to={"/contratos/gerenciar/" + row.id}
                        >
                          <i className="material-icons">settings</i>
                        </Link>
                        <Link
                          title="Aditivos"
                          className="btn btn-primary btn-simple btn-xs"
                          to={"/aditivos/" + row.id}
                        >
                          <i className="material-icons">note_add</i>
                        </Link>
                        <button
                          type="button"
                          rel="tooltip"
                          title="Remover contrato"
                          onClick={() => this.delete(row.id)}
                          className="btn btn-danger btn-simple btn-xs"
                        >
                          <i className="material-icons">close</i>
                        </button>
                      </div>
                      <div>
                        <Link
                          title="Ver baixas do contrato"
                          className="btn btn-primary btn-simple btn-xs"
                          to={"/notas/" + row.id}
                        >
                          <i className="material-icons">trending_down</i>
                        </Link>
                        <Link
                          title="Editar contrato"
                          className="btn btn-primary btn-simple btn-xs"
                          to={"/contratos/edit/" + row.id}
                        >
                          <i className="material-icons">edit</i>
                        </Link>
                      </div>
                      <div>
                        <button
                          onClick={() => this.getFicha(row.id)}
                          type="button"
                          rel="tooltip"
                          title="Vizualizar contrato"
                          className="btn btn-info btn-simple btn-xs"
                        >
                          <i className="material-icons">local_printshop</i>
                        </button>
                        <Link
                          title="Digitalizações"
                          className="btn btn-primary btn-simple btn-xs"
                          to={"/digitalizados/" + row.id}
                        >
                          <i className="material-icons">insert_drive_file</i>
                        </Link>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <ReactPaginate
            previousLabel="Anterior"
            nextLabel="Próximo"
            breakLabel={<a href="">...</a>}
            breakClassName="break-me"
            pageCount={this.props.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={30}
            onPageChange={this.props.handlePageClick}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
          />
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableContratos)



// WEBPACK FOOTER //
// ./src/views/contratos/TableContratos.js